import React from 'react';
import { Typography } from 'antd';
import { RobotOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function AssistantLoadingMessage({ phase = 'opening' }) {
  const label = (
    {
      opening: 'Working on it',
      reading: 'Reading CMS sources',
      drafting: 'Drafting answer',
      verifying: 'Checking CMS sources',
    }[phase] || 'Working on it'
  );
  return (
    <div className="glp1-message glp1-message--assistant glp1-message--loading" aria-live="polite">
      <div className="glp1-message-bubble">
        <div className="glp1-thinking-row">
          <RobotOutlined aria-hidden="true" />
          <Text>{label}</Text>
          <span className="glp1-thinking-dots" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </div>
        <span className="glp1-sr-only">{label}.</span>
      </div>
    </div>
  );
}
